import { render, staticRenderFns } from "./Cerfication.vue?vue&type=template&id=21812593&scoped=true&"
import script from "./Cerfication.vue?vue&type=script&lang=js&"
export * from "./Cerfication.vue?vue&type=script&lang=js&"
import style0 from "./Cerfication.vue?vue&type=style&index=0&id=21812593&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21812593",
  null
  
)

export default component.exports